import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import SearchIcon from "@mui/icons-material/Search";
import Card from "react-bootstrap/Card";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import ValueContext from "../utils/contextAPI/contextAPI";

import "../css/createTemplate.scss";
import BannerCard from "./BannerCard";
import {
  getAlleDetail,
  getBrandDetails,
  getCampaignDetails,
  getMarketDetails,
  searchForDetails,
} from "../services/apis";
import CircularProgressBar from "../utils/CircularProgressBar";
import { eDetail, template } from "../utils/constants";
import LibrarySearchIcon from "../images/library-searchIcon.svg";
import { showErrorToast } from "./toastComponent/ToastComponent";

export default function CreateTemplate(props) {
  const {
    isOpenCreateFromTemp,
    setIsOpenCreateFromTemp,
    type,
    createPresentationFields,
    setCreatePresentationFields,
    onProceedHandler,
    sharedToggle,
    setSharedToggle,
    onToggleProceedHandler,
    localShared,
  } = props;
  const [isChecked, setIsChecked] = useState("");
  const [filterName, setFilter] = useState("filter");
  const [searchPayload, setSearchPayload] = useState({
    searchInput: "",
    brand: createPresentationFields.brand,
    market: [],
    campaign: [],
    device: [],
    createdByMe: "createdByMe",
    locked: true,
  });
  const [edetailLists, setEdetailList] = useState(undefined);
  const [isloading, setIsloading] = useState(true);
  const [brandDetails, setBrandDetails] = useState(undefined);
  const [marketDetails, setMarketDetails] = useState(undefined);
  const [campaignDetails, setCampaignDetails] = useState(undefined);
  const [selectedCard, setSelectedCard] = useState([]);
  const [disabledBtn, setDisabledBtn] = useState(true);
  const [selectedCardList, setSelectedCardList] = useState([]);
  const appData = useContext(ValueContext);

  // const [deviceDetails, setDeviceDetails] = useState([
  //   {
  //     name: "Device",
  //     deleted: false,
  //     desc: "",
  //     _id: "",
  //   },
  // ]);

  const errNotify = () => showErrorToast('Presentation failed to fetch');

  useEffect(() => {
    getBrandDetail();
    getMarketDetail();
    // getCampaignDetail();
  }, []);

  useEffect(() => {
    searchResult(searchPayload);
  }, [searchPayload]);

  const getBrandDetail = () => {
    getBrandDetails((response, err) => {
      if (err) {
        showErrorToast('Failed to fetch Brand');
      } else {
        const filterdCampaign = response.data.filter(
          (item) => item._id === searchPayload.brand
        );
        setCampaignDetails(filterdCampaign[0].campaigns);
        setBrandDetails(filterdCampaign[0].name);
        //setBrandDetails(response.data);
      }
    });
  };

  const canceledToggle = () => {
    setIsOpenCreateFromTemp(false);
    setCreatePresentationFields({
      presentationName: "",
      brand: "",
      market: "",
      dimension: "",
      device: "",
      campaign: "",
      templateName: "",
    });
  };

  const getMarketDetail = () => {
    getMarketDetails((response, err) => {
      if (err) {
        showErrorToast('Failed to fetch Market Detalis');
      } else {
        setMarketDetails(response.data);
      }
    });
  };

  const searchResult = () => {
    let start = 0;
    let limit = 1000;
    let type = 1;
    // let createdbyMe = true;

    searchPayload.skip = start;
    searchPayload.limit = limit;
    // searchPayload.createdByMe = createdbyMe;
    searchPayload.type = type;

    if (
      searchPayload.searchInput === "" &&
      searchPayload.market.length === 0 &&
      searchPayload.campaign.length === 0 &&
      searchPayload.device.length === 0 &&
      searchPayload.createdByMe === "createdByMe" &&
      searchPayload.brand === ""
    ) {
      getAlleDetail({
        type: type,
        start: start,
        limit: limit,
        createdbyMe: true,
        callBack: (response, err, errorCode) => {
          if (err) {
            errNotify();
            showErrorToast('Failed to fetch');
            setIsloading(false);
          } else {
            setEdetailList(response.data.decks);
            setIsloading(false);
          }
        },
      });
    } else {
      let searchPayloadLocal = { ...searchPayload };
      searchPayloadLocal.market = searchPayloadLocal.market.toString();
      searchPayloadLocal.device = searchPayloadLocal.device.toString();
      searchPayloadLocal.campaign = searchPayloadLocal.campaign.toString();
      searchPayloadLocal.createdByMe =
        searchPayloadLocal.createdByMe === "createdByMe" ? true : false;

      searchPayload.locked =
        searchPayloadLocal.createdByMe === "createdByMe" ? "" : false;
      searchForDetails(searchPayloadLocal, (response, err, errorCode) => {
        if (err) {
          errNotify();
          setIsloading(false);
        } else {
          setEdetailList(response.data.decks);
          setIsloading(false);
        }
      });
    }
  };

  const handleChangeSearchFields = (e) => {
    const value = e.target.value;
    const specialChars = /[`!@#$%^&*+\=\[\]{};':"\\|,.<>\/?~]/;
    if (specialChars.test(value) || value.includes(" ")) {
      return;
    } else {
      setSearchPayload(value);
      setSearchPayload({ ...searchPayload, searchInput: value });
      setIsloading(false);
    }
  };

  const handleChangeFilter = (e, id, name, brandName) => {
    Object.keys(searchPayload).forEach((key) => {

      if (key === name) {
        // let data;
        // if (name === "brand") {
        // setIsChecked(brandName);
        // const brandData = brandDetails?.find((brand) => brand._id === id);
        // setSearchPayload({ ...searchPayload, [key]: brandData._id });
        // setIsloading(false);
        //}
        if (name === "market") {
          if (e.target.checked) {
            const marketData = marketDetails?.find((brand) => brand._id === id);
            setSearchPayload({
              ...searchPayload,
              [key]: [...searchPayload[key], marketData._id],
            });
            setIsloading(false);
          } else {
            const index = searchPayload[key].indexOf(id);
            let array = [...searchPayload[key]];
            if (index > -1) {
              // only splice array when item is found
              array.splice(index, 1); // 2nd parameter means remove one item only
            }
            setSearchPayload({ ...searchPayload, [key]: array });
            setIsloading(false);
          }
        }
        if (name === "campaign") {
          if (e.target.checked) {
            const campData = campaignDetails?.find((brand) => brand._id === id);
            setSearchPayload({
              ...searchPayload,
              [key]: [...searchPayload[key], campData._id],
            });
            setIsloading(false);
          } else {
            const index = searchPayload[key].indexOf(id);
            let array = [...searchPayload[key]];
            if (index > -1) {
              // only splice array when item is found
              array.splice(index, 1); // 2nd parameter means remove one item only
            }
            setSearchPayload({ ...searchPayload, [key]: array });
            setIsloading(false);
          }
        }
        if (name === "device") {
          if (e.target.checked) {
            const deviceData = appData.devices?.find(
              (device) => device._id === id
            );
            let arryVal = [...searchPayload[key], deviceData._id];
            setSearchPayload({
              ...searchPayload,
              [key]: arryVal,
            });
            setIsloading(false);
          } else {
            const index = searchPayload[key].indexOf(id);
            let array = [...searchPayload[key]];
            if (index > -1) {
              // only splice array when item is found
              array.splice(index, 1); // 2nd parameter means remove one item only
            }
            setSearchPayload({ ...searchPayload, [key]: array });
            setIsloading(false);
          }
        }
        if (name === "createdByMe") {
          if (e?.target?.value === "createdByOthers")
            setSearchPayload({
              ...searchPayload,
              [key]: e?.target?.value,
              locked: false,
            });
          else if (e?.target?.value === "createdByMe") {
            setSearchPayload({
              ...searchPayload,
              [key]: e?.target?.value,
              locked: true,
            });
          }
        }
      }
    });
  };
  const handleSelectCardsdisabled = () => {
    if (selectedCard.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  return (
    <>
      <Modal
        show={isOpenCreateFromTemp}
        onHide={canceledToggle}
        fullWidth={true}
        size="lg"
        centered
        className="create-template-filter-modal"
      >
        <Modal.Body className="filter-modal-body">
          <div className="row create-from-template">
            {/* <div className="create-template-header"> */}
            <h2 className="create-template-header">
              <span className="choose-text">Choose</span>
              <span className="template-text">Template</span>
              <span className="brand-text">Brand</span>
              <span className="brand-name">{brandDetails}</span>
            </h2>
            {/* <h2>
              </h2> */}
            {/* </div> */}
            <hr style={{ padding: 0, margin: 0, color: "#e2e2e2", opacity: 1 }} />
            <div className="row g-0 create-template-content">
              <div className="col-md-3 left-filter">
                <div className="filter-by-list">
                  <h2 className="filter-by-text"> Filter by </h2>
                  <hr className="filter-by-list-hr" />
                  <div className="filter-by-list-content">
                    <div className=" customScrollBar customAccordIcons">
                      <h2 className="created-by-text">Created by</h2>
                      <RadioGroup
                        defaultValue="me"
                        name="radio-buttons-group"
                        className="select-me"
                      >
                        <FormControlLabel
                          value={"createdByMe"}
                          className="me-button"
                          control={<Radio />}
                          label="Me"
                          name="createdByMe"
                          checked={"createdByMe" === searchPayload.createdByMe}
                          onChange={(event) =>
                            handleChangeFilter(event, "id", "createdByMe")
                          }
                        />
                        <FormControlLabel
                          value={"createdByOthers"}
                          className="others-buttons"
                          control={<Radio />}
                          checked={
                            "createdByOthers" === searchPayload.createdByMe
                          }
                          label="Others"
                          name="createdByOthers"
                          onChange={(event) =>
                            handleChangeFilter(event, "id", "createdByMe")
                          }
                        />
                      </RadioGroup>
                      {/* <Accordion
                    defaultExpanded={false}
                    // onChange={handleChangeVeeva("panel1")}
                    className="filter-by-template"
                  >
                    <AccordionSummary className="filter-by-template-name">
                      <span className="filter-by-brand-name">
                        Product/Brand
                      </span>
                    </AccordionSummary>
                    <AccordionDetails className="filter-by-brand-content">
                      {brandDetails?.map((brandList, index) => (
                        <div className="checkbox" key={brandList._id}>
                          <input
                            type="radio"
                            value={brandList._id}
                            checked={isChecked === brandList.name}
                            name={brandList.name}
                            onChange={(event) =>
                              handleChangeFilter(
                                event,
                                brandList._id,
                                "brand",
                                brandList.name
                              )
                            }
                          />
                          <label htmlFor="">{brandList.name}</label>
                        </div>
                      ))}
                    </AccordionDetails>
                  </Accordion> */}
                      <Accordion className="filter-by-template">
                        <AccordionSummary className="filter-by-template-name">
                          <span className="filter-by-brand-name">Market</span>
                        </AccordionSummary>
                        <AccordionDetails className="filter-by-brand-content">
                          {marketDetails?.map((marketList, index) => (
                            <div className="checkbox" key={marketList._id}>
                              <input
                                type="checkbox"
                                value={marketList._id}
                                name={marketList.name}
                                onChange={(event) =>
                                  handleChangeFilter(
                                    event,
                                    marketList._id,
                                    "market"
                                  )
                                }
                              />
                              <label htmlFor="">{marketList.name}</label>
                            </div>
                          ))}
                        </AccordionDetails>
                      </Accordion>
                      <Accordion className="filter-by-template">
                        <AccordionSummary className="filter-by-template-name">
                          <span className="filter-by-brand-name">Device</span>
                        </AccordionSummary>
                        <AccordionDetails className="filter-by-brand-content">
                          {appData.devices?.map((deviceList, index) => (
                            <div className="checkbox" key={deviceList._id}>
                              <input
                                type="checkbox"
                                value={deviceList._id}
                                name={deviceList.name}
                                onChange={(event) =>
                                  handleChangeFilter(
                                    event,
                                    deviceList._id,
                                    "device"
                                  )
                                }
                              />
                              <label htmlFor="">{deviceList.name}</label>
                            </div>
                          ))}
                        </AccordionDetails>
                      </Accordion>
                      <Accordion className="filter-by-template">
                        <AccordionSummary className="filter-by-template-name">
                          <span className="filter-by-brand-name">Campaign</span>
                        </AccordionSummary>
                        <AccordionDetails className="filter-by-brand-content">
                          {campaignDetails?.map((campaignList, index) => (
                            <div className="checkbox" key={campaignList._id}>
                              <input
                                type="checkbox"
                                value={campaignList._id}
                                name={campaignList.name}
                                onChange={(event) =>
                                  handleChangeFilter(
                                    event,
                                    campaignList._id,
                                    "campaign"
                                  )
                                }
                              />
                              <label htmlFor="">{campaignList.name}</label>
                            </div>
                          ))}
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-9 right-filter">
                <div className="filter-list">
                  {/* <h2> Choose Template </h2> */}
                  <div className="row g-0 filter-search">
                    <div className="create-from-template-searchRow">
                      <div class="input-placeholder">
                        <img
                          alt="search"
                          src={LibrarySearchIcon}
                          className={"searchManagerIcon"}
                        />
                        <input
                          value={searchPayload.searchInput}
                          id="choose-search-template"
                          type="text"
                          name="searchInput"
                          onChange={(e) =>
                            handleChangeSearchFields(e, "searchInput")
                          }
                          onKeyDown={(e) =>
                            handleChangeSearchFields(e)}
                          autoComplete="off"
                          // pattern=
                          required
                        />
                        <div class="placeholder" htmlFor="choose-search-template">
                          <span> Search by <span> ‘Template name / ID’</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {isloading && (
                    <CircularProgressBar
                      isloading={isloading}
                      setIsloading={setIsloading}
                    />
                  )}
                  <div className="filter-list-content customScrollBar">
                    <div className="row">
                      {edetailLists && edetailLists.length > 0
                        ? edetailLists
                          .filter((element) => element.type === template)
                          .map((item, index) => {
                            const imageKey = Date.now();
                            return (
                              <div
                                className="col-md-4 modal-banner-card"
                                key={index}
                              >
                                <BannerCard
                                  type={type}
                                  cardData={item}
                                  filterName={filterName}
                                  setSelectedCard={setSelectedCard}
                                  setDisabledBtn={setDisabledBtn}
                                  selectedCardList={selectedCardList}
                                  setSelectedCardList={setSelectedCardList}
                                  selectedCard={selectedCard}
                                  imageKey={imageKey}
                                />
                              </div>
                            );
                          })
                        : !isloading && <div>Data Not Found</div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="create-template-filter-footer">
          <div className="col-md-10 d-grid gap-2 d-md-flex justify-content-md-end footer">
            <Button onClick={() => canceledToggle()} className="cancel">
              CANCEL
            </Button>
            <Button
              className="proceed"
              onClick={() => onProceedHandler(selectedCard)}
              disabled={handleSelectCardsdisabled()} //{selectedCardList.length > 0 ? false : true}
            >
              {localShared ? "NEXT" : "GO TO EDITOR"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
